export default __webpack_public_path__ + "img/a0dc0fc36bcdf2d580d50516a8fc6a59.svg";